// PointItem.js
import { POINT } from '../constants';
import { lerpExp } from '../utils';

export function createPointItem(imageCache) {
  return function PointItem(
    id,
    src,
    activeSrc,
    x,
    y,
    {
      scale = POINT.SCALE,
      hitRadius = POINT.HIT_RADIUS,
      fadeSpeed = POINT.FADE_SPEED,
    } = {},
  ) {
    const normalRec = imageCache.load(src);
    const activeRec = imageCache.load(activeSrc);

    return {
      type: 'point',
      id,

      x,
      y,

      hitRadius,

      active: false,
      mix: 0,

      get cx() {
        return this.x;
      },
      get cy() {
        return this.y;
      },

      setActive(on) {
        this.active = !!on;
      },

      update(dt) {
        const prev = this.mix;
        const target = this.active ? 1 : 0;
        this.mix = lerpExp(this.mix, target, fadeSpeed, dt);
        return Math.abs(this.mix - prev) > 1e-4;
      },

      draw(ctx, sceneAlpha = 1) {
        if (!normalRec.ready || !activeRec.ready) return;

        const a = sceneAlpha;
        if (a <= 0.001) return;

        // 2배 스케일링
        const w = (normalRec.w / 2) * scale;
        const h = (normalRec.h / 2) * scale;

        const dx = this.x - w / 2;
        const dy = this.y - h / 2;

        const prevA = ctx.globalAlpha;

        const nA = (1 - this.mix) * a;
        if (nA > 0.001) {
          ctx.globalAlpha = prevA * nA;
          ctx.drawImage(normalRec.img, dx, dy, w, h);
        }

        const aA = this.mix * a;
        if (aA > 0.001) {
          ctx.globalAlpha = prevA * aA;
          ctx.drawImage(activeRec.img, dx, dy, w, h);
        }

        ctx.globalAlpha = prevA;
      },

      hitTest(px, py) {
        const dx = px - this.x;
        const dy = py - this.y;
        return dx * dx + dy * dy <= hitRadius * hitRadius;
      },
    };
  };
}
